import Turbolinks from 'turbolinks';

const N2 = {};
N2.handlers = [];

const N2Ready = (callback) => {
  $(document).on('turbolinks:load', callback);
};

const N2Unload = (callback) => {
  $(document).on('turbolinks:before-visit', callback);
};

// manually unbind local event handler, typically you don't need to use this.
const N2OffHandle = (evt, selector) => {
  $(selector).off(evt);
};

// manually unbind global event handler, typically you don't need to use this.
const N2UnbindGlobalHandler = (evt, selector) => {
  $(document).off(evt, selector);
};

/**
 * bind a handler to document, automatically unbind on TL page nav only do this
 * if your event handler really needs to be present on every page.
 */
const N2BindGlobalHandler = (evt, selector, callback) => {
  $(document).on(evt, selector, callback);
  N2.handlers.push(['global', evt, selector]);
};

/**
 * bind an event handler to elements matching selector, automatically unbound
 * on TL page nav.
 */
const N2Handle = (evt, selector, callback) => {
  $(selector).on(evt, callback);
  N2.handlers.push(['local', evt, selector]);
};

/**
 * auto unbind all N2.handlers registered events handlers. called on TL page
 * navigation.
 */
const N2UnbindHandlers = () => {
  N2.handlers.forEach((evtInfo) => {
    if (evtInfo[0] === 'global') {
      N2UnbindGlobalHandler(evtInfo[1], evtInfo[2]);
    } else {
      N2OffHandle(evtInfo[1], evtInfo[2]);
    }
  });

  N2.handlers = [];
};

// Turbolinks API method, wrapped for global usage.
const N2Navigate = (location, options) => {
  Turbolinks.visit(location, options);
};

export {
  N2Ready, N2Unload, N2BindGlobalHandler, N2Handle,
  N2UnbindHandlers, N2UnbindGlobalHandler, N2OffHandle, N2Navigate,
};
